import React from "react";
import { Flag, RefreshCw, ExternalLink, Check, Sparkles, Loader2 } from "lucide-react";

export default function AdminTipsList({
  tips,
  loading,
  onRefresh,
  onResolve,
  onClaudeIngest,
  ingestingTipId,
}) {
  return (
    <div className="border border-zinc-900 bg-white" data-testid="admin-tips-list">
      <div className="px-5 py-3 border-b border-zinc-900 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Flag size={14} className="text-red-600" />
          <span className="label-eyebrow">Community tips</span>
          <span className="text-[10px] font-bold text-zinc-500">
            ({tips.length})
          </span>
        </div>
        <button
          onClick={onRefresh}
          disabled={loading}
          className="text-[10px] uppercase tracking-widest font-bold text-zinc-700 hover:text-red-600 inline-flex items-center gap-1 disabled:opacity-50"
          data-testid="admin-tips-refresh"
        >
          <RefreshCw size={11} className={loading ? "animate-spin" : ""} />
          Refresh
        </button>
      </div>

      <div className="divide-y divide-zinc-200 max-h-[520px] overflow-auto">
        {tips.length === 0 && !loading && (
          <div className="p-6 text-sm text-zinc-500">No pending tips.</div>
        )}
        {tips.map((t) => (
          <TipRow
            key={t.id}
            tip={t}
            onResolve={() => onResolve(t.id)}
            onClaude={() => onClaudeIngest(t)}
            ingesting={ingestingTipId === t.id}
          />
        ))}
      </div>
    </div>
  );
}

function TipRow({ tip, onResolve, onClaude, ingesting }) {
  return (
    <div className="p-4 hover:bg-zinc-50" data-testid={`tip-row-${tip.id}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <div className="font-display font-black text-base tracking-tight">
            {tip.abuser_name}
          </div>
          <div className="text-xs text-zinc-600 mt-0.5">
            {[tip.city, tip.state].filter(Boolean).join(", ") || "—"}
          </div>
          <p className="text-sm text-zinc-700 mt-2 leading-relaxed line-clamp-3">
            {tip.crime_description}
          </p>
          <div className="mt-2 flex items-center gap-3 text-[11px] text-zinc-500">
            <a
              href={tip.source_url}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1 hover:text-red-600"
              data-testid={`tip-row-source-${tip.id}`}
            >
              <ExternalLink size={10} /> Source
            </a>
            {tip.tipster_email && (
              <span>tipster: {tip.tipster_email}</span>
            )}
            <span>
              {new Date(tip.submitted_at).toLocaleDateString()}
            </span>
          </div>
        </div>
        <div className="flex flex-col gap-2 shrink-0">
          <button
            onClick={onClaude}
            disabled={ingesting}
            className="px-3 py-1.5 border border-red-600 bg-red-600 text-white text-[10px] uppercase tracking-widest font-bold inline-flex items-center gap-1.5 hover:bg-red-700 disabled:opacity-50"
            data-testid={`tip-row-claude-${tip.id}`}
          >
            {ingesting ? (
              <Loader2 size={11} className="animate-spin" />
            ) : (
              <Sparkles size={11} />
            )}
            {ingesting ? "Ingesting…" : "Run Claude"}
          </button>
          <button
            onClick={onResolve}
            className="px-3 py-1.5 border border-zinc-300 text-zinc-700 text-[10px] uppercase tracking-widest font-bold inline-flex items-center gap-1.5 hover:border-zinc-900 hover:text-zinc-900"
            data-testid={`tip-row-resolve-${tip.id}`}
          >
            <Check size={11} /> Resolve
          </button>
        </div>
      </div>
    </div>
  );
}
